export const ETB_DATA_KEY = "eras-tour-bracelets-data";
export const ETB_RESULTS_KEY = "eras-tour-bracelets-results";
export const ETB_SETTINGS_KEY = "eras-tour-bracelets-settings";
export const ETB_DATA_FILENAME = "eras-tour-bracelets-website-backup.json";
export const ETB_COOKIE_BANNER = "eras-tour-cookie-banner-seen";
